<template>
  <div class="caseS">
    <img src="./image/caseS.png" alt="H">
  </div>
</template>

<script>
export default {
  name: 'CmhkH5CaseS',

  data () {
    return {

    };
  },

  mounted () {

  },

  methods: {

  },
};
</script>


<style lang="scss" scoped>
.caseS {
  position: relative;
  width: 100vw;
  height: 100vh;

  >img {
    width: 100%;
  }
}
</style>